import script from "./TextAreaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&setup=true&lang=js"

import "./TextAreaInput.vue?vue&type=style&index=0&id=5235e66a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5235e66a"]])

export default __exports__